/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Cargo_Checklist_DescriptionInputs */

const en_audit_cargo_checklist_description = /** @type {(inputs: Audit_Cargo_Checklist_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter actual bag counts for each cargo lot. Variance is calculated automatically.`)
};

const es_audit_cargo_checklist_description = /** @type {(inputs: Audit_Cargo_Checklist_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingrese los conteos reales de sacos para cada lote de carga. La variacion se calcula automaticamente.`)
};

/**
* | output |
* | --- |
* | "Enter actual bag counts for each cargo lot. Variance is calculated automatically." |
*
* @param {Audit_Cargo_Checklist_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_cargo_checklist_description = /** @type {((inputs?: Audit_Cargo_Checklist_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Cargo_Checklist_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_cargo_checklist_description(inputs)
	return es_audit_cargo_checklist_description(inputs)
});